import { useQuery } from "react-query";
import { getStatusAuthorizedIvideon } from "../requests/getStatusAuthorizedIvideon";

export default function useGetStatusAuthorizedIvideon(id: string) {
  return useQuery({
    queryKey: ["mainPageStatusAuthorizedIvideon", { id }],
    queryFn: () => getStatusAuthorizedIvideon(id),
    refetchOnWindowFocus: false,
    enabled: !!id,
  });
}
